<template>
    <div>
      <Modal
        id="fast-track-modal"
        :showModal="fastTrackModalVisible"
        :closeable="false"
        @close="closeFastTrackModal"
        :optionalStyles="modalStyles()"
        >
          <template #header>
            <div class="px-8 d-flex justify-start pt-3">
              <h5 class="text-center">Congratulations! You qualify for our FastTrack experience.</h5>
            </div>
          </template>

          <template #body>
            <div class="px-9 d-flex text-center mt-2">
              <p>FastTrack is a fully automated experience where you can see options in less than 5 minutes.</p>
            </div>
          </template>

          <template #footer>
            <div class="d-flex justify-content-center modal-footer mb-4">
              <div class="close">
                <button 
                  class="btn btn-outline-primary" 
                  @click="closeFastTrackModal()"
                >
                    <span class="btn-text">No Thanks</span>
                </button>
              </div>
                <button 
                  class="btn btn-primary"
                  @click="launchEmbeddedApplication()"
                >
                      <span>Continue with FastTrack</span>
                </button>
            </div>
          </template>

      </Modal>
    </div>
  </template>
  
  <script>
  import { mapState } from 'pinia'
  import Modal from '~/components/modal.vue'
  import get from 'lodash/get'
  import { useBorrowerStore } from '~/store/borrower'
  
  export default {
    name: 'FastTrackModal',
    components: {
      Modal,
    },
    computed: {
      ...mapState(useBorrowerStore, ['fastTrackModalVisible'])
    },
    methods: {
      launchEmbeddedApplication() {
        this.$emit('launchEmbeddedApplication')
      },
      closeFastTrackModal() {
        useBorrowerStore(this.$pinia).toggleFastTrackModalVisibility(false)
      },
      modalStyles() {
        return {
          'modal-wrapper': {
            'display': 'grid',
            'place-items': 'center',
            'width': '100%',
            'height': '100%'
          },
          'modal-dialog': {
            'width': '522px',
            'height': 'auto'
          },
          'modal-content': {
            'border-radius': '16px',
          },
        }
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  #fast-track-modal {
    h5 {
      font-size: 22px;
      line-height: 28px;
    }
    .close {
      margin-right: 10px !important;
    }
  }
  </style>
  